var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2.25 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.355 7.396H13.144V15.847999999999999H0.355z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.75,
    cy: 11.622,
    rx: 1.421,
    ry: 1.409
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.303 3.874C10.322 1.948 8.763.372 6.82.352H6.75C4.808.333 3.217 1.878 3.197 3.803v3.593"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueUnlocked);
export default __webpack_public_path__ + "static/media/blue-unlocked.e685f5fc8b5dd6bde922cf759a435ae4.svg";
export { ForwardRef as ReactComponent };